import { Dialog } from "@headlessui/react";
import { Button } from "../button/button";
import Lottie from "lottie-react";
import Successful from "../../../../public/assets/lotties/successful.json";
import Error from "../../../../public/assets/lotties/error.json";

export type modalProps = {
  title?: string;
  text?: string;
  type?: "error" | "success";
  modal: boolean;
  children?:React.ReactNode
  onClose: () => void;
  buttonLabel: string;
  onClick: () => void;
};

export const Modal = ({
  title,
  text,
  type,
  modal,
  onClose,
  buttonLabel,
  onClick,
  children
}: modalProps) => {
  return (
    <Dialog
      open={modal}
      onClose={onClose}
      className="fixed inset-0  z-50 flex items-center justify-center"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <Dialog.Panel className="bg-white relative items-center justify-center flex flex-col max-w-sm p-6 rounded-md shadow-xl w-full">
        {type === "error" ? (
          <div className={"success-modal-img"}>
            {/*<img src={errorImg} width={70} height={70} alt=""/>*/}
            <Lottie
              animationData={Error}
              style={{ width: "100px", height: "100px" }}
              loop={true}
            />
          </div>
        ) : (
          <div className={"success-modal-img"}>
            <Lottie
              animationData={Successful}
              style={{ width: "100px", height: "100px" }}
              loop={true}
            />
            {/*<img src={successImg} width={70} height={70} alt=""/>*/}
          </div>
        )}
        <Dialog.Title className="text-lg text-black font-semibold mb-2">
          {title}
        </Dialog.Title>
        {text && <p className="text-gray-600 mb-4">{text}</p>}
        <div className="text-lg text-black font-semibold mb-2">
          {children}
        </div>
        <Button
          className="w-full"
          label={buttonLabel}
          onClick={() => {
            onClick();
            onClose();
          }}
        />
      </Dialog.Panel>
    </Dialog>
  );
};
